<template>
  <div>
    <b-modal
      id="error-age"
      ref="modal"
      title=""
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
    >
      <div class="header">
        <h3>Спасибо за честный ответ <br /></h3>

        <div class="text">
          Мы&nbsp;заботимся о&nbsp;здоровье будущего поколения, поэтому сайт
          не&nbsp;доступен лицам младше 18&nbsp;лет.
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: [""],

  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.header {
  flex-direction: column;
  width: 100%;

  h3 {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 30px;
    font-weight: 800;
    font-family: $regular;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;
  }
}

.text {
  color: white;
  font-size: 16px;
}
</style>
